<template>
  <v-main class="pa-5">
    <v-container fluid>
      <!-- Main Card with Locations Table -->
      <v-card class="elevation-4 rounded-lg">
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-map-marker-multiple</v-icon>
          <span class="headline font-weight-bold">Locais da Unidade</span>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar local"
            single-line
            hide-details
            dark
            clearable
            class="search-field"
          ></v-text-field>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="listaLocais"
          :search="search"
          :loading="loading"
          :no-data-text="noDataText"
          :no-results-text="noResultsText"
          class="elevation-1"
          mobile-breakpoint="0"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class="font-weight-medium">{{ item.nomeLocal }}</td>
              <td class="text-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      color="primary"
                      v-on="on"
                      @click="editarLocal(item)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar local</span>
                </v-tooltip>
              </td>
            </tr>
          </template>

          <template v-slot:loading>
            <v-progress-linear indeterminate color="primary"></v-progress-linear>
          </template>
        </v-data-table>
      </v-card>

      <!-- Floating Add Button -->
      <v-btn
        fab
        dark
        color="primary"
        fixed
        bottom
        right
        class="mb-10 mr-4 elevation-6"
        :to="{ path: '/cadastrarLocalUnidade' }"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-container>
  </v-main>
</template>

<script>
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'ListaLocaisUnidade',
  data () {
    return {
      search: '',
      loading: false,
      headers: [
        {
          text: 'Nome do Local',
          value: 'nomeLocal',
          align: 'start',
          sortable: true,
          class: 'primary--text font-weight-bold'
        },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: '120px',
          class: 'primary--text font-weight-bold'
        }
      ],
      listaLocais: [],
      noDataText: 'Nenhum local cadastrado',
      noResultsText: 'Nenhum resultado encontrado'
    }
  },
  mounted () {
    this.carregarLocais()
  },
  methods: {
    async carregarLocais () {
      this.loading = true
      try {
        const response = await administradorUnidadeService.administradorUnidade.retornarLocais()
        this.listaLocais = response.data || []
      } catch (error) {
        console.error('Erro ao carregar locais:', error)
        this.$notify({
          type: 'error',
          title: 'Erro',
          text: 'Não foi possível carregar a lista de locais'
        })
      } finally {
        this.loading = false
      }
    },
    editarLocal (item) {
      this.$router.push({
        name: 'alterarDadosLocal',
        params: { item }
      })
    }
  }
}
</script>

<style scoped>
.rounded-lg {
  border-radius: 12px;
}

.v-card__title {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.search-field {
  max-width: 300px;
}

.v-btn--floating {
  position: fixed;
  z-index: 4;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .v-card__title {
    flex-direction: column;
    align-items: flex-start;
  }

  .search-field {
    margin-top: 12px;
    width: 100%;
    max-width: none;
  }
}
</style>
